"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../utils");
const icons_1 = require("../icons");
const __utils_1 = __importDefault(require("../styles/_.utils"));
const SelectInitialForm_1 = __importDefault(require("../styles/SelectInitialForm"));
exports.default = (0, mobx_react_1.observer)(({ store, handlers }) => (react_1.default.createElement("div", null,
    react_1.default.createElement("h4", null, "SELECT A FORM"),
    (0, utils_1.mapo)(store.menu, (key, val) => 
    // eslint-disable-next-line
    react_1.default.createElement("button", { key: key, value: key, className: (0, classnames_1.default)(__utils_1.default.button, SelectInitialForm_1.default.btn), onClick: handlers.handleInitialFormSelect },
        react_1.default.createElement(icons_1.FaCircleO, { className: SelectInitialForm_1.default.icon }),
        " ",
        val)))));
